/**
 * Notificación in-app al autor tras moderar una publicación de Comunidad (RPC admin_notify_user).
 * @returns {{ error: Error|null }}
 */
export async function notifyComunidadAutorModeracion(
  supabase,
  { recipientId, publicationId, publicationTitle, approved, rejectCodigo = null, rejectLabel = null, rejectDetalle = null }
) {
  if (!recipientId) return { error: null };
  const pub = String(publicationTitle || '').trim() || 'Tu publicación';
  const title = approved ? 'Publicación aprobada en Comunidad' : 'Publicación no publicada (Comunidad)';
  let body;
  if (approved) {
    body = `Tu propuesta «${pub}» ya está aprobada y visible en el feed de Comunidad. ¡Gracias por compartirla!`;
  } else {
    const motivo = String(rejectLabel || 'Revisión de moderación').trim();
    body = `Tu propuesta «${pub}» no se ha publicado tras la revisión del equipo.\n\nMotivo: ${motivo}.`;
    const det = String(rejectDetalle || '').trim();
    if (det) body += `\n\nDetalle: ${det}`;
    body += '\n\nPuedes enviar una nueva propuesta desde Comunidad cuando lo desees.';
  }
  const { error } = await supabase.rpc('admin_notify_user', {
    p_user_id: recipientId,
    p_type: approved ? 'comunidad_publicacion_aprobada' : 'comunidad_publicacion_rechazada',
    p_title: title,
    p_body: body,
    p_data: {
      publication_id: publicationId,
      rechazo_codigo: approved ? null : rejectCodigo,
    },
  });
  return { error: error || null };
}
